import Vue from "vue";

// import Cookies from 'js-cookie'
import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";

import "@/styles/index.scss"; // global css

import App from "./App";

import "./icons"; // icon
import Axios from "axios";

Vue.prototype.$axios = Axios;
Axios.defaults.baseURL = "/api";

Vue.use(Element);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  render: h => h(App)
});
